(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var View = require('../views/itinerary')
  , Model = require('../models/itinerary')
  , Collection = require('../collections/itinerary')
  , debug = require('../../../../admin/source/js/app/lib/debug')('router')

module.exports = function (serviceLocator) {
  var router = serviceLocator.router
    , collection = new Collection()
    , displayName = { singular: 'Itinerary', plural: 'Itineraries' }

  router.route('itineraries/form', function () {

    debug('itinerary url list view route triggered')

    if (!serviceLocator.allow('itinerary', 'read')) {
      return false
    }

    var view = new View(
      { title: displayName.singular
      , serviceLocator: serviceLocator
      , model: new Model()
      }
    )

    router.render(view, displayName.plural)
  })

  router.route('itinerary/:id/form(/)', 'editItinerary', function (id) {
    if (!serviceLocator.allow('itinerary', 'update')) {
      return false
    }
    debug('itinerary edit view route triggered')

    collection.retrieve(id, function (err, model) {
      if (err) {
        router.trigger('notFound', err.message)
        return
      }
      debug('Loading form view', model)
      var view = new View(
        { model: model
        , title: displayName.singular
        , serviceLocator: serviceLocator
        })

      view.on('cancel', function () {
        router.navigate('contract/shows', { trigger: true })
      })

      router.render(view, displayName.plural)
    })
  })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/itinerary/controllers/controller.js","/components/admin/itinerary/controllers")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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